import { rootReducer } from './reducers';
import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
    reducer: rootReducer as any,
    middleware: (getDefaultMiddleware: (arg0: { immutableCheck: boolean; serializableCheck: boolean; }) => any) => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false
    })
});